import { useQuery } from '@apollo/client';
import styles from './idea-activity-log.module.less';
import { ActivityLog, GET_IDEA_ACTIVITY_LOG } from '@frontend/data-access';
import { List, Typography } from 'antd';
import { UserAvatar } from '@frontend/shared/ui';
import { formatDate } from '@frontend/shared/util';
import useTranslation from 'next-translate/useTranslation';

const { Text } = Typography;
/* eslint-disable-next-line */
export interface IdeaActivityLogProps {
  ideaId: string;
}

// type ActivityLogAction = 'CREATE' | 'READ' | 'UPDATE' | 'DELETE';
// type ActivityLogType = 'PHASE' | 'REVIEWER' | 'EXPERT' | 'SCORE' | 'COMMENT';

export function IdeaActivityLog({ ideaId }: IdeaActivityLogProps) {
  const { t } = useTranslation('common');
  const { data, loading } = useQuery<{
    activityLogs: ActivityLog[];
  }>(GET_IDEA_ACTIVITY_LOG, {
    variables: { ideaId },
    fetchPolicy: 'no-cache',
  });

  const renderText = (log: ActivityLog) => {
    if (log.action === 'CREATE' && log.type === 'COMMENT') {
      return t('commented_on_evaluation_comment');
    } else if (log.action === 'UPDATE' && log.type === 'SCORE') {
      return t('updated_score_to', { newValue: log.newValue });
    } else if (log.action === 'UPDATE' && log.type === 'REVIEWER') {
      return t('invited_the_reviewer', { newValue: log.newValue });
    } else if (log.action === 'CREATE' && log.type === 'REVIEWER') {
      return t('assigned_the_reviewer', { newValue: log.newValue });
    } else if (log.action === 'DELETE' && log.type === 'REVIEWER') {
      return t('removed_the_reviewer', { oldValue: log.oldValue });
    } else if (log.action === 'CREATE' && log.type === 'EXPERT') {
      return t('assigned_the_expert', { newValue: log.newValue });
    } else if (log.action === 'DELETE' && log.type === 'EXPERT') {
      return t('removed_the_expert', { oldValue: log.oldValue });
    } else if (log.action === 'UPDATE' && log.type === 'PHASE') {
      return t('changed_the_phase', { newValue: log.newValue });
    } else if (log.action === 'UPDATE' && log.type === 'TARGET') {
      return t('changed_the_target', { newValue: log.newValue });
    } else {
      return t('undefined_action_and_type');
    }
  };

  return (
    <div className={styles['container']}>
      <List
        size="small"
        loading={loading}
        dataSource={data?.activityLogs}
        split={false}
        renderItem={(item) => (
          <List.Item className="mb-2">
            <div className="flex items-center gap-2">
              <UserAvatar user={item.created} size={32} />
              <div>
                <Text className="space-x-1 !text-sm">
                  <span className="!text-gray-900 !font-medium">
                    {item.created.fullName}
                  </span>
                  <span className="text-gray-700">{renderText(item)}</span>
                </Text>
                <div className="text-sm text-gray-700">
                  {formatDate(item.createdAt, 'DD MMM YYYY, HH:mm')}
                </div>
              </div>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
}

export default IdeaActivityLog;
